import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {Tag} from "../../model/tag";
import {ContentService} from "../../services/content.service";
import {DeviceService} from "../../services/device.service";
import {Subscription} from "rxjs";
import {constants} from "../../constants";
import {ClassService} from "../../services/class.service";

declare var $: any;

@Component({
  selector: 'app-genres-slider',
  templateUrl: './genres-slider.component.html',
  styleUrls: ['./genres-slider.component.css']
})
export class GenresSliderComponent implements OnInit {
  private _tagsSlider: ElementRef;
  private arrowsShown: boolean;
  private itemsNumber: number;

  private itemWidth: number;

  tags: ReadonlyArray<Tag>;

  readonly tagsClasses = ['mood_type_01', 'mood_type_02', 'mood_type_03', 'mood_type_04', 'mood_type_05', 'mood_type_06', 'mood_type_07', 'mood_type_08', 'mood_type_09',
    'mood_type_10', 'mood_type_11', 'mood_type_12', 'mood_type_13', 'mood_type_14', 'mood_type_15', 'mood_type_16', 'mood_type_17', 'mood_type_18', 'mood_type_19', 'mood_type_20']

  subscription: Subscription;

  constructor(private readonly contentService: ContentService,
              readonly deviceService: DeviceService,
              private readonly classService: ClassService) {
    this.arrowsShown = false;
    this.itemsNumber = 5;

    this.itemWidth = 259;

    this.tags = [];

    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.subscription.add(
      this.contentService.tagsList.subscribe(value => this.tags = value.filter(tag => !constants.mainPageSkippedTags.includes(tag.id)))
    );
  }

  @ViewChild("tagsSlider") set tagsSlider(value: ElementRef) {
    this.removeSlider();

    this._tagsSlider = value;

    this.initHitsSlider();
  }

  @HostListener('window:resize')
  resize(): void {
    if (this._tagsSlider) {
      if (window.innerWidth > constants.desktopScreenBreakpoint && !this.arrowsShown) {
        this.updateSlider();
      }

      if (window.innerWidth <= constants.desktopScreenBreakpoint && this.arrowsShown) {
        this.updateSlider();
      }

      if (this.itemsNumber != Math.min(Math.trunc(window.innerWidth / this.itemWidth), 5)) {
        this.updateSlider();
      }
    }
  }

  getClassForTag(index: number, tag: Tag): string {
    switch (tag.id) {
      case 77:
      case 68: return "mood_type_02";
      case 391: return "mood_type_05";
      case 82: return "mood_type_11";
      default: {
        return this.tagsClasses[index % this.tagsClasses.length];
      }
    }
  }

  initHitsSlider(): void {
    if (this._tagsSlider) {
      $(this._tagsSlider.nativeElement).slick({
        infinite: false,
        slidesToShow: window.innerWidth > constants.desktopScreenBreakpoint ? 5 : 2,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: true,
        arrows: window.innerWidth > constants.desktopScreenBreakpoint
      });
      this.arrowsShown = window.innerWidth > constants.desktopScreenBreakpoint;
      this.itemsNumber = Math.min(Math.trunc(window.innerWidth / this.itemWidth), 5);
    }
  }

  removeSlider(): void {
    if (this._tagsSlider) {
      $(this._tagsSlider.nativeElement).slick("unslick");
    }
  }

  updateSlider(): void {
    this.removeSlider();
    this.initHitsSlider();
  }

  ngOnDestroy(): void {
    this.removeSlider()

    this.subscription.unsubscribe();
  }

  getIconClass(tag: Tag) {
    return this.classService.getIconClass(tag)
  }
}
